import React, { useState } from "react";

import { Form, Button, message, DatePicker, Radio } from "antd";

import { DownloadOutlined } from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";

import styles from "./Report.module.less";

function Report({ brand }) {
  const [submit, setSubmit] = useState(false);

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setSubmit(true);
    values.brandId = brand.id;
    if (values.startTime) {
      values.startTime = values.startTime.format("YYYY-MM-DD HH:mm:ss");
    }
    if (values.endTime) {
      values.endTime = values.endTime.format("YYYY-MM-DD HH:mm:ss");
    }
    let para = queryString.stringify(values);
    try {
      let blob = await Http.get(values.type + "/export", {
        searchParams: para,
        timeout: 15 * 60 * 1000,
      }).blob();
      let url = URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = `File_${new Date().getTime()}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      await message.error("接口调用错误");
    } finally {
      setSubmit(false);
    }
  };

  return (
    <div className={styles.Report}>
      <div className={styles.header}>
        <DownloadOutlined />
        <i>报表下载</i>
      </div>
      <div className={styles.content}>
        <Form
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 9 }}
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            label="类型"
            name="type"
            rules={[{ required: true, message: "请选择类型" }]}
          >
            <Radio.Group>
              <Radio value="news">新闻</Radio>
              <Radio value="product">产品</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="时间" style={{ marginBottom: 0 }} required>
            <Form.Item
              name="startTime"
              rules={[{ required: true, message: "请选择开始时间" }]}
              style={{ display: "inline-block", width: "50%" }}
            >
              <DatePicker
                placeholder="请选择开始时间"
                format="YYYY-MM-DD"
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item
              name="endTime"
              rules={[{ required: true, message: "请选择结束时间" }]}
              style={{
                display: "inline-block",
                width: "calc(50% - 16px)",
                margin: "0 0 0 16px",
              }}
            >
              <DatePicker
                placeholder="请选择结束时间"
                format="YYYY-MM-DD"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Form.Item>
          <Form.Item
            label="格式"
            name="format"
            rules={[{ required: true, message: "请选择格式" }]}
          >
            <Radio.Group>
              <Radio value="csv">CSV</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 2 }}>
            <Button
              type="primary"
              disabled={submit}
              loading={submit}
              htmlType="submit"
            >
              提交
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
export default Report;
